<template>
  <div class="container">
    <div class="container_box">
      <!-- 顶部操作栏 -->
      <header class="header">
        <div v-if="totalQuestions > 0 && !showHistory" class="question-progress">
          共 {{ totalQuestions }} 题，当前第 {{ currentQuestion }} 题
        </div>
        <div class="header_box" @click="toggleHistory">
          <img src="@/assets/images/histo01.png" alt="" />
          <div class="header_box_text">
            {{ showHistory ? "关闭历史" : "历史记录" }}
          </div>
        </div>
      </header>

      <template v-if="showHistory">
        <!-- 聊天消息区域 -->
        <main
          class="chat-area show-history"
          :class="loading ? 'show-history-loading' : ''"
        >
          <div
            v-for="(msg, index) in chatHistory"
            :key="index"
            :class="['message', `${msg.type}-message`]"
          >
            <div v-if="msg.type === 'ai'" class="avateAi">
              <img :src="aiAvatar" alt="AI头像" />
            </div>
            <div v-else-if="msg.type === 'user'" class="userAvate">
              <img src="@/assets/images/userAvate.png" alt="用户头像" />
            </div>

            <div
              v-if="msg.content || msg.rawContent"
              :class="['bubble', `${msg.type}-bubble`]"
            >
              <RobotAssistantContent
                v-if="msg.type === 'ai' && msg.useRichParser"
                :text="msg.rawContent || ''"
                :goods-id="goodsId"
              />
              <div v-else v-html="msg.content"></div>
            </div>
            <div v-show="msg.type === 'time'" class="timestamp">
              {{ msg.timestamp }}
            </div>
          </div>
        </main>
      </template>

      <template v-else>
        <main class="chat-area">
          <div
            v-for="(msg, index) in chatList"
            :key="index"
            :class="[
              'message',
              msg.type === 'ai' ? 'ai-message' : 'user-message',
            ]"
          >
            <div v-if="msg.type === 'ai'" class="avateAi">
              <img :src="aiAvatar" alt="AI头像" />
            </div>
            <div v-else-if="msg.type === 'user'" class="userAvate">
              <img src="@/assets/images/userAvate.png" alt="用户头像" />
            </div>
            <div
              v-if="msg.content || msg.rawContent || msg.loading"
              :class="[
                'bubble',
                msg.type === 'ai' ? 'ai-bubble' : 'user-bubble',
              ]"
            >
              <div v-if="msg.loading" class="ai-typing" aria-label="加载中">
                <span></span>
                <span></span>
                <span></span>
              </div>
              <template v-else>
                <RobotAssistantContent
                  v-if="msg.type === 'ai' && msg.useRichParser"
                  :text="msg.rawContent || ''"
                  :goods-id="goodsId"
                />
                <div v-else v-html="msg.content"></div>
              </template>
            </div>
          </div>
        </main>
      </template>

      <!-- 输入区域 -->
      <footer v-show="!showHistory" class="footer">
        <div class="footer_top">
          <textarea
            class="input-box"
            v-model="userInput"
            @keydown.enter.prevent="handleSend"
            placeholder="此处回答问题"
            @input="autoResize"
          >
          </textarea>
          <div class="btn-retry">
            <!-- 操作按钮组 -->
            <div class="btn-group-box">
              <div
                v-if="doYouAnswer && !showRetry"
                class="btn-next"
                @click="nextQuestion"
              >
                {{ isLastQuestion ? "学习建议" : "下一题" }}
              </div>
              <div v-if="showRetry" class="btn-begin" @click="resetQuiz">
                重新作答
              </div>
            </div>
            <div class="btn-send-group">
              <xmlVoiceRecognition
                class="btn-voice"
                @getVoiceData="getVoiceData"
              />
              <div class="btn-send" @click="handleSend">
                <img src="@/assets/images/send.png" alt="" />
              </div>
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>

<script>
import {
  GUIDED_LEARNING_CONFIG,
  resolveGuidedLearningConfig,
  fetchGuidedLearningChapters,
  fetchGuidedLearningSessions,
  fetchGuidedLearningMessages,
  streamGuidedLearningChat,
} from "@/utils/guidedLearningApi";
import xmlVoiceRecognition from "@/components/voice/xmlVoiceRecognition";
import RobotAssistantContent from "@/components/robot/RobotAssistantContent.vue";
import { goodsInfoDetail } from "@/api/bookstore/bookstore";
import defaultAiAvatar from "@/assets/icon/xiaozhi_logo.png";

export default {
  components: { xmlVoiceRecognition, RobotAssistantContent },
  data() {
    const guidedConfig = resolveGuidedLearningConfig(this.$route.query);
    return {
      // bookId / chapterId：路由 query 可覆盖，否则用默认值；flowId/source 不默认传给中转服务，由服务端按环境补齐
      bookId: guidedConfig.bookId || "",
      chapterId: guidedConfig.chapterId || "",
      flowId: this.$route.query.flowId || "",
      source: this.$route.query.source || "",
      userId: this.$route.query.userId || GUIDED_LEARNING_CONFIG.userId || "",
      goodsId: this.$route.query.goodsId || "",
      systemPrompt: GUIDED_LEARNING_CONFIG.systemPrompt || "",

      questionList: [], // 章节题目列表
      currentQuestion: 1, // 当前题目序号（从 1 开始）
      totalQuestions: 0,
      sessionId: "", // 对话会话 ID
      hasLoaded: false, // load 动作最多调用一次

      chatList: [
        {
          content:
            "您好，欢迎您使用AI智疑功能，我是您的专属AI训练老师kiki，接下来开始我们的练习吧！",
          rawContent: "",
          useRichParser: false,
          timestamp: Date.now(),
          type: "ai",
        },
      ],
      chatHistory: [],
      userInput: "",
      showHistory: false,
      showRetry: false,
      loading: false,
      doYouAnswer: false,
      submitting: false,
      xiaoZhi: {},
    };
  },

  computed: {
    currentQuestionItem() {
      return this.questionList[this.currentQuestion - 1] || null;
    },
    nextQuestionItem() {
      return this.questionList[this.currentQuestion] || null;
    },
    isLastQuestion() {
      return this.totalQuestions > 0 && this.currentQuestion >= this.totalQuestions;
    },
    aiAvatar() {
      return this.xiaoZhi.imageUrl || defaultAiAvatar;
    },
    apiConfig() {
      const config = {
        bookId: this.bookId,
        chapterId: this.chapterId,
        userId: this.userId,
        systemPrompt: this.systemPrompt || null,
      };
      if (this.flowId) config.flowId = this.flowId;
      if (this.source) config.source = this.source;
      return config;
    },
  },

  mounted() {
    this.getAiDate();
    this.initializeUser();
  },

  methods: {
    autoResize() {},

    getAiDate() {
      if (!this.goodsId) return;
      goodsInfoDetail(this.goodsId).then((res) => {
        if (res.code == 200 && res.data.xiaoZhi) {
          this.xiaoZhi = res.data.xiaoZhi;
        }
      });
    },

    getApiConfigOrTip() {
      const missing = [];
      if (!this.bookId) missing.push("bookId");
      if (!this.chapterId) missing.push("chapterId");
      if (missing.length) {
        const tip = `请先补齐配置：${missing.join("、")}`;
        this.$message && this.$message.error
          ? this.$message.error(tip)
          : console.error(tip);
        return null;
      }
      return this.apiConfig;
    },

    /**
     * 初始化：拉取章节题目，可选 load，再展示第一题
     */
    async initializeUser() {
      if (this.userId) {
        sessionStorage.setItem("customerId", this.userId);
      }
      await this.fetchQuestionList();
    },

    async fetchQuestionList() {
      const config = this.getApiConfigOrTip();
      if (!config) return;
      try {
        const res = await fetchGuidedLearningChapters({
          ...config,
          pageNum: 1,
          pageSize: 100,
        });
        const list = (res && res.data && res.data.pageListInfos) || [];
        this.questionList = list.slice().sort((a, b) => (a.order || 0) - (b.order || 0));
        this.totalQuestions = this.questionList.length;
        if (!this.questionList.length) {
          this.addMessage("ai", "当前章节暂无可学习题目", "question");
          return;
        }
        await this.startCurrentQuestion({ withLoad: true });
      } catch (error) {
        console.error("获取章节题目失败:", error);
        this.addMessage(
          "ai",
          error.message || "获取题目失败，请稍后重试",
          "question"
        );
      }
    },

    /**
     * 进入当前题：不展示章节接口的 content，题干由 chatStream 返回
     */
    async startCurrentQuestion({ withLoad = false } = {}) {
      const question = this.currentQuestionItem;
      if (!question) return;

      this.doYouAnswer = false;
      this.scrollToBottom();

      if (withLoad && !this.hasLoaded) {
        await this.callLoadAction(question.id);
      }
    },

    async callLoadAction(questionAttemptId) {
      const config = this.getApiConfigOrTip();
      if (!config || !questionAttemptId) return;

      this.addMessage("ai", "", "question", { loading: true });
      const messageIndex = this.chatList.length - 1;

      try {
        const result = await streamGuidedLearningChat({
          action: "load",
          content: "",
          sessionId: this.sessionId,
          questionAttemptId,
          config,
          onUpdate: ({ content, sessionId }) => {
            if (sessionId) this.sessionId = sessionId;
            if (content) {
              this.updateAiMessage(messageIndex, {
                loading: false,
                useRichParser: true,
                rawContent: content,
                content: "",
              });
              this.scrollToBottom();
            }
          },
        });
        this.hasLoaded = true;
        if (result.sessionId) this.sessionId = result.sessionId;
        this.updateAiMessage(messageIndex, { loading: false });
        if (!result.content) {
          this.chatList.splice(messageIndex, 1);
        }
      } catch (error) {
        console.error("初始化学习会话失败:", error);
        this.updateAiMessage(messageIndex, {
          loading: false,
          useRichParser: false,
          rawContent: "",
          content: this.renderStreamError(error, "获取题目失败，请稍后重试"),
        });
      }
    },

    async nextQuestion() {
      if (!this.doYouAnswer) {
        this.$message.error("请先回答当前问题！");
        return;
      }

      const current = this.currentQuestionItem;
      if (!current) return;

      const config = this.getApiConfigOrTip();
      if (!config) return;

      const isAdvice = this.isLastQuestion;
      const next = isAdvice ? null : this.nextQuestionItem;
      if (!isAdvice && !next) return;

      try {
        this.addMessage("ai", "", isAdvice ? "advice" : "question", {
          loading: true,
        });
        const analysisIndex = this.chatList.length - 1;
        const result = await streamGuidedLearningChat({
          action: "next",
          content: "",
          sessionId: this.sessionId,
          questionAttemptId: current.id,
          nextQuestionAttemptId: next ? next.id : "",
          config,
          onUpdate: ({ content, sessionId }) => {
            if (sessionId) this.sessionId = sessionId;
            if (content) {
              this.updateAiMessage(analysisIndex, {
                loading: false,
                useRichParser: true,
                rawContent: content,
                content: "",
              });
              this.scrollToBottom();
            }
          },
        });
        if (result.sessionId) this.sessionId = result.sessionId;
        this.updateAiMessage(analysisIndex, { loading: false });
        if (!result.content) {
          this.chatList.splice(analysisIndex, 1);
        }

        if (isAdvice) {
          this.showRetry = true;
          return;
        }

        // 下一题题干已由 next 的流式返回展示，不再使用章节接口 content
        this.currentQuestion += 1;
        this.doYouAnswer = false;
        this.scrollToBottom();
      } catch (error) {
        console.error(isAdvice ? "获取学习建议失败:" : "进入下一题失败:", error);
        const last = this.chatList[this.chatList.length - 1];
        if (last && last.loading) {
          this.updateAiMessage(this.chatList.length - 1, {
            loading: false,
            useRichParser: false,
            rawContent: "",
            content: this.renderStreamError(
              error,
              isAdvice ? "获取学习建议失败" : "进入下一题失败"
            ),
          });
        }
        this.$message && this.$message.error
          ? this.$message.error(
              error.message || (isAdvice ? "获取学习建议失败" : "进入下一题失败")
            )
          : null;
      }
    },

    handleSend() {
      const answer = this.userInput.trim();
      if (!answer || this.submitting) return;
      if (answer.length > 600) {
        this.$message.error("回答不能超过 600 字");
        return;
      }
      if (!this.currentQuestionItem) {
        this.$message.error("当前没有可作答题目");
        return;
      }
      this.addMessage("user", answer, "answer");
      this.submitAnswer(answer);
      this.userInput = "";
    },

    getVoiceData(text) {
      if (!text) return;
      this.userInput = text;
    },

    addMessage(type, content, contentType, extra = {}) {
      const useRichParser = !!(extra.useRichParser && type === "ai" && !extra.loading);
      const rawContent = useRichParser ? content || "" : "";
      const message = {
        type,
        content: extra.loading
          ? ""
          : useRichParser
          ? ""
          : marked.parse(content?.replace(/\\n/g, "<br/>") || ""),
        rawContent,
        useRichParser,
        timestamp: Date.now(),
        question: this.currentQuestion,
        contentType,
        loading: !!extra.loading,
      };
      this.chatList.push(message);
      this.$nextTick(this.scrollToBottom);
    },

    updateAiMessage(index, patch) {
      if (!this.chatList[index]) return;
      this.$set(this.chatList, index, {
        ...this.chatList[index],
        ...patch,
      });
    },

    renderStreamError(error, fallbackText) {
      return marked.parse((error && error.message) || fallbackText || "请求失败，请稍后重试");
    },

    async submitAnswer(answer) {
      const config = this.getApiConfigOrTip();
      const question = this.currentQuestionItem;
      if (!config || !question) return;

      this.submitting = true;
      this.addMessage("ai", "", "analysis", { loading: true });
      const analysisIndex = this.chatList.length - 1;

      try {
        const result = await streamGuidedLearningChat({
          action: "answer",
          content: answer,
          sessionId: this.sessionId,
          questionAttemptId: question.id,
          config,
          onUpdate: ({ content, sessionId }) => {
            if (sessionId) this.sessionId = sessionId;
            if (content) {
              this.updateAiMessage(analysisIndex, {
                loading: false,
                useRichParser: true,
                rawContent: content,
                content: "",
              });
              this.scrollToBottom();
            }
          },
        });
        if (result.sessionId) this.sessionId = result.sessionId;
        this.updateAiMessage(analysisIndex, { loading: false });
        this.doYouAnswer = true;
      } catch (error) {
        console.error("提交回答失败:", error);
        this.updateAiMessage(analysisIndex, {
          loading: false,
          useRichParser: false,
          rawContent: "",
          content: this.renderStreamError(error, "解析失败，请稍后再试"),
        });
      } finally {
        this.submitting = false;
      }
    },

    /**
     * 历史：先查会话列表，再拉最近会话的消息
     */
    async fetchHistory() {
      const config = this.getApiConfigOrTip();
      if (!config) {
        this.chatHistory = [];
        return;
      }
      this.loading = true;
      try {
        const sessionRes = await fetchGuidedLearningSessions({
          ...config,
          pageNum: 1,
          pageSize: 20,
        });
        const sessions =
          (sessionRes && sessionRes.data && sessionRes.data.pageListInfos) || [];
        if (!sessions.length) {
          this.chatHistory = [];
          return;
        }

        // 优先使用当前会话；否则取最新一条
        const currentSession =
          sessions.find((item) => item.id === this.sessionId) || sessions[0];
        const messageRes = await fetchGuidedLearningMessages({
          sessionId: currentSession.id,
          pageNum: 1,
          pageSize: 100,
        });
        const messages =
          (messageRes && messageRes.data && messageRes.data.pageListInfos) || [];
        const sorted = messages
          .slice()
          .sort((a, b) => (a.order || 0) - (b.order || 0));

        const history = [
          {
            type: "time",
            content: "",
            timestamp: this.formatDisplayTime(
              currentSession.createTime || currentSession.modifyTime
            ),
          },
        ];
        sorted.forEach((msg) => {
          const senderType = String(msg.senderType || "").toLowerCase();
          const isUser = senderType === "user";
          const text = msg.content || "";
          history.push({
            type: isUser ? "user" : "ai",
            content: isUser
              ? marked.parse(text.replace(/\\n/g, "<br/>") || "")
              : "",
            rawContent: isUser ? "" : text,
            useRichParser: !isUser,
            timestamp: "",
          });
        });
        this.chatHistory = history;
        this.$nextTick(this.scrollToBottom);
      } catch (error) {
        console.error("获取历史记录失败:", error);
        this.chatHistory = [];
        this.$message && this.$message.error
          ? this.$message.error(error.message || "获取历史记录失败")
          : null;
      } finally {
        this.loading = false;
      }
    },

    formatDisplayTime(value) {
      if (!value) return "";
      const date = new Date(value);
      if (Number.isNaN(date.getTime())) return String(value);
      return date.toLocaleString();
    },

    toggleHistory() {
      this.showHistory = !this.showHistory;
      if (!this.showHistory) {
        this.$nextTick(this.scrollToBottom);
      } else {
        this.fetchHistory();
      }
    },

    async resetQuiz() {
      this.chatList = [
        {
          content:
            "您好，欢迎您使用AI智疑功能，我是您的专属AI训练老师kiki，接下来开始我们的练习吧！",
          rawContent: "",
          useRichParser: false,
          timestamp: Date.now(),
          type: "ai",
        },
      ];
      this.showRetry = false;
      this.currentQuestion = 1;
      this.doYouAnswer = false;
      this.sessionId = "";
      this.hasLoaded = false;
      // 新会话重新 load，由 chatStream 返回第一题题干
      await this.startCurrentQuestion({ withLoad: true });
    },

    scrollToBottom() {
      const chatArea = this.$el.querySelector(".chat-area");
      if (chatArea) {
        chatArea.scrollTop = chatArea.scrollHeight;
      }
    },
  },
};
</script>

<style scoped lang="scss">
.container {
  background: #f2f2f2;
  padding: 12px 10px;
  min-height: 100vh;
}
.container_box {
  max-width: 800px;
  height: calc(100vh - 24px);
  border-radius: 20px;
  background: #ffffff;
  padding: 14px 16px 0px 20px;
  margin: 0 auto;
}
/* 顶部模块 */
.header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 6px;
  .question-progress {
    font-family: MicrosoftYaHei;
    font-size: 14px;
    color: #4b58ed;
    background-color: #e9f5ff;
    border-radius: 5px;
    padding: 4px 10px;
    line-height: 22px;
  }
  .header_box {
    margin-left: auto;
    cursor: pointer;
    display: flex;
    align-items: center;
    font-family: MicrosoftYaHei;
    font-size: 14px;
    padding: 0px 7px 0px 0px;
    background-color: #e9f5ff;
    border-radius: 5px;
    color: #6c91ff;
    img {
      width: 22px;
      margin-right: 3px;
    }
  }
}
.history-btn {
  font-size: 14px;
  color: #999;
  background: none;
  border: 0;
  float: right;
  cursor: pointer;
}
.history-btn:hover {
  color: #666;
  text-decoration: underline;
}

/* 聊天区域 */
.chat-area {
  flex: 1;
  height: calc(100% - 246px);
  overflow-y: auto;
  padding-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 18px;
  .avateAi {
    width: 36px;
    transform: translateY(-20px);
    img {
      width: 36px;
      height: 36px;
      border-radius: 50%;
      object-fit: cover;
      display: block;
    }
  }
  .userAvate {
    width: 36px;
  }
}

.show-history {
  position: relative;
  height: calc(100% - 50px);
}
.show-history-loading::after {
  position: absolute;
  left: 0;
  top: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  content: "加载中...";
  width: 100%;
  height: 100%;
  background-color: #ffffff;
  animation: loading 1s infinite;
}
/* 消息气泡通用样式 */
.message {
  width: 100%;
  display: flex;
  gap: 4px;
  user-select: text !important;
}
.avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  flex-shrink: 0;
}
.bubble {
  padding: 12px 10px 16px 10px;
  border-radius: 8px;
  font-family: MicrosoftYaHei;
  font-size: 14px;

  line-height: 1.5;
  color: #333;
}
.timestamp {
  width: 100%;
  text-align: center;
  font-size: 14px;
  color: #777;
}
/* AI消息 */
.ai-message {
  align-self: flex-start;
}
.ai-bubble {
  max-width: calc(100% - 150px);
  background-image: linear-gradient(
    90deg,
    #e3e4ff 0%,
    #e0eeff 65%,
    #ddf7ff 100%
  );
}
.ai-typing {
  display: flex;
  align-items: center;
  gap: 6px;
  min-height: 18px;
  padding: 2px 4px;
  span {
    width: 7px;
    height: 7px;
    border-radius: 50%;
    background: #6c91ff;
    opacity: 0.35;
    animation: ai-typing 1.1s ease-in-out infinite;
    &:nth-child(2) {
      animation-delay: 0.16s;
    }
    &:nth-child(3) {
      animation-delay: 0.32s;
    }
  }
}
@keyframes ai-typing {
  0%,
  80%,
  100% {
    opacity: 0.28;
    transform: translateY(0);
  }
  40% {
    opacity: 1;
    transform: translateY(-3px);
  }
}
@media (prefers-reduced-motion: reduce) {
  .ai-typing span {
    animation: none;
    opacity: 0.7;
  }
}
/* 用户消息 */
.user-message {
  align-self: flex-end;
  flex-direction: row-reverse;
  gap: 20px;
}
.user-bubble {
  max-width: calc(100% - 150px);
  background: linear-gradient(white, white) padding-box,
    linear-gradient(to right, #e3e4ff, #e0eeff, #ddf7ff) border-box;
  border: 3px solid transparent;
  border-radius: 8px;
}

/* 底部操作栏 */
.footer {
  width: 100%;
  padding-top: 40px;

  .footer_top {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    min-height: 130px;
    border: 1px solid #c9c9c9;
    border-radius: 12px;
    padding: 16px 12px 0px 16px;
    background: #f2f2f2;
    .btn-retry {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      padding: 10px 0;
    }
  }
  .btn-send-group {
    position: relative;
    display: flex;
    align-items: center;
    gap: 12px;
    padding-left: 12px;
    &::before {
      content: "";
      position: absolute;
      left: 0;
      top: 0;
      width: 1px;
      height: 30px;
      background-color: #c9c9c9;
    }
  }
  .btn-voice {
    display: flex;
    align-items: center;
    justify-content: center;
  }
  .btn-send {
    position: relative;
    width: 30px;
    height: 30px;
    background-color: #d1d4df;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    img {
      width: 18px;
    }
    &:hover {
      opacity: 0.8;
      background-color: #88a2ff;
    }
  }
}
.input-box {
  resize: none;
  height: 80px;
  overflow-y: auto;
  width: 100%;
  font-size: 14px;
  border: 0px;
  background: #f2f2f2;
}
.input-box:focus {
  outline: none;
  border-color: #999;
}
.btn-group-box {
  display: flex;
  align-items: flex-end;
  gap: 12px;

  .btn-next {
    width: 90px;
    height: 30px;
    background-color: #e0ecff;
    border-radius: 20px;

    color: #4b58ed;
    line-height: 30px;
    text-align: center;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    font-weight: bold;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
  .btn-begin {
    width: 90px;
    height: 30px;
    background-image: linear-gradient(
      90deg,
      #787eff 0%,
      #5ea8ff 65%,
      #44d1ff 100%
    );
    border-radius: 20px;
    color: #ffffff;
    line-height: 30px;
    text-align: center;
    font-family: MicrosoftYaHei;
    font-size: 12px;
    cursor: pointer;
    &:hover {
      opacity: 0.8;
    }
  }
}
.btn {
  flex: 1;
  height: 36px;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  cursor: pointer;
}
.btn-next {
  background: #007bff;
  color: white;
}
.btn-send {
  background: #007bff;
  color: white;
  width: 36px;
  padding: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}
.send-icon {
  width: 24px;
  height: 24px;
  transition: transform 0.2s;
}
.btn-send:hover .send-icon {
  transform: scale(1.1);
}
.btn-send:active .send-icon {
  transform: scale(0.9);
}
</style>

<style lang="scss">
.chat-area {
  .message {
    * {
      user-select: text;
    }
  }
}
</style>
